import axios from 'axios';
import { CONTENT_API_BASE_URL } from '../data/Constants';

const contentClient = axios.create({
  baseURL: `${CONTENT_API_BASE_URL}`
});

contentClient.interceptors.response.use((response) => response.data);

contentClient.interceptors.request.use((config: any) => {
  return {
    ...config,
    headers: {
      ...config.headers
    }
  };
});

export default contentClient;
